import React from 'react'
import { motion } from "framer-motion";

const ContactHero = () => {
  return (
     <section className="about-hero">

      <div className="hero-container">

        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2 className="hero_head">
           Let’s Build Something Powerful Together
          </h2>

          <p className="hero-text">
            Tell us about your idea — we’ll turn it into reality.
          </p>

        </motion.div>
        <div className="hero-right">
           <div className="blob">
            <img className="cover-img"
              src="./contact-hero.webp"
              alt="team"
              loading='lazy'
            />
          </div>

        </div>

      </div>
    </section>
  )
}

export default ContactHero